import { spLogTags } from '@eventr/common'
import { Typography } from '@eventr/common-storybook'

export const Emoji = ({
    big = false,
    emoji,
}: {
    big?: boolean
    emoji: any
}) => {
    function getEmojiValue(emoji: any) {
        if (emoji.unicode) {
            return emoji.unicode
        } else if (emoji.value.type === 'PLAIN_TEXT') {
            return emoji.value.value
        } else {
            try {
                spLogTags('unkown emoji', ['markdown'])
                spLogTags(emoji, ['markdown'])
                return emoji.value.value
            } catch {
                return ''
            }
        }
    }

    return (
        <Typography
            variant={'bodyRegular'}
            fontSize={big ? '40px' : undefined}
            lineHeight={'1em'}
        >
            {getEmojiValue(emoji)}
        </Typography>
    )
}
